import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../services/user.service';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { TableUtil } from '../admintrademaster/tableUtil';
import * as moment from 'moment';
import { TransactionService } from "../services/transaction.service";

@Component({
    selector: 'app-withdrawbatch',
    templateUrl: './withdrawbatch.component.html',
    styleUrls: ['./withdrawbatch.component.css']
})

export class WithdrawBatchComponent implements OnInit {
    displayedColumns = [
        'batch_id',
        'status',
        'createdAt',
        'updatedAt',
    ];
    fromDate;
    toDate;
    filter: any = {};
    public selectedDate = new Date();
    public selectedDate1 = new Date();
    dataSource: MatTableDataSource<withdrawBatchData>;
    pageSize = 10;
    pageSizeOptions = [5, 10, 25, 50, 100];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    constructor(
        private userService: UserService,
        private transactionService: TransactionService,
        public dialog: MatDialog
    ) { }

    ngOnInit() {
        this.csrf();
        this.applyRefreshData();
        this.filter['fDate'] = moment(this.selectedDate).format('yyyy-MM-DD');
        this.filter['tDate'] = moment(this.selectedDate1).format('yyyy-MM-DD');
    }
    fromDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.fromDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['fDate'] = this.fromDate;
    }
    async toDateFilter(type: string, event: MatDatepickerInputEvent<Date>) {
        this.toDate = moment(event.value).format('yyyy-MM-DD');
        this.filter['tDate'] = this.toDate;
    }
    applyFilter(filterValue: string) {
        filterValue = filterValue.trim(); // Remove whitespace
        filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
        this.dataSource.filter = filterValue;
    }
    async applyRefreshData() {
        this.userService.csrf().subscribe(data => {
            this.filter['_csrf'] = data._csrf;
            this.transactionService.getWithdrawBatchs(this.filter).subscribe((success) => {
                let withdrawBatchRes = success.map(withdrawBatchTrans => {
                    withdrawBatchTrans.status = withdrawBatchTrans.status ? withdrawBatchTrans.status : 'Pending';
                    withdrawBatchTrans.createdAt = moment(withdrawBatchTrans.createdAt).format('MM/DD/YY h:mm:ss A');
                    withdrawBatchTrans.updatedAt = moment(withdrawBatchTrans.updatedAt).format('MM/DD/YY h:mm:ss A');
                    return withdrawBatchTrans;
                })
                this.dataSource = new MatTableDataSource(withdrawBatchRes);
                this.dataSource.paginator = this.paginator
                this.dataSource.sort = this.sort;
            })
        })
    }
    async exportArray() {
        if (this.dataSource.filteredData) {
            const withdrawBatch = await this.dataSource.filteredData.map(x => ({
                "Batch Id": x.batch_id,
                "Status": x.status,
                "Created At": x.createdAt,
                "Updated At": x.updatedAt,
            }));
            TableUtil.exportArrayToExcel(withdrawBatch, "Withdraw Batch");
        }

    }
    csrf() {
        this.userService.csrf().subscribe((success) => this.filter['_csrf'] = success._csrf)
    }
}
export interface withdrawBatchData {
    batch_id: string,
    status: string,
    createdAt: string,
    updatedAt: string,
} 


// WEBPACK FOOTER //
// ./src/app/withdraw-batch/withdrawbatch.component.ts